<template>
  <div class="pa-0 ma-0" style="background-color:#f5f5f5" fluid>
    <v-dialog v-model="addEntitiesWindow" max-width="800px">
      <v-card>
        <v-card-title>
          <span>Add to Cluster</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="addEntitiesWindow = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ClusterEntitySelector v-if="entity.entity_type == 'publisher'" :cluster-id="entity.id"
            @entities-added="onEntitiesAdded" @success="onSuccess" @error="onError" />
          <ClusterSupplierSelector v-else :cluster-id="entity.id" @entities-added="onEntitiesAdded" @success="onSuccess"
            @error="onError" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div>
      <v-container class="px-0 pt-3 mt-0 mr-2" fluid>
        <v-row class="ma-0 pt-0" fluid>
          <v-col cols="12" md="12" class="pt-0 mb-0 pb-0">
            <v-row class="mx-auto px-0 py-0" style="background-color:#f5f5f5">
              <v-col cols="12" class="px-0 pb-0 pt-2">

                <v-card tile>
                  <v-card-title style="color:#12253a;">

                    <span class="d-inline-block text-truncate" style="max-width:600px; min-width:150px;">
                      <v-card-subtitle color="secondary" class="pa-0 font-weight-light">{{ clusterType
                      }}</v-card-subtitle>
                      {{ entity.name }}

                    </span>
                    <div class="flex-grow-1"></div>
                    <span class="mr-3">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" outlined dense :loading="savingClusterType"
                            style="min-width: 150px; text-transform: none;" class="text-uppercase">
                            {{ getClusterTypeName(selectedClusterType) || 'Cluster Type' }}
                            <v-icon right>mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item v-for="clusterType in clusterTypes" :key="clusterType.id"
                            @click="onClusterTypeChange(clusterType.id)"
                            :class="{ 'v-list-item--active': selectedClusterType === clusterType.id }">
                            <v-list-item-content>
                              <v-list-item-title>{{ clusterType.name }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon v-if="selectedClusterType === clusterType.id">
                              <v-icon color="primary">mdi-check</v-icon>
                            </v-list-item-icon>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </span>
                    <span>
                      <v-btn class="mr-3" outlined @click="addEntitiesWindow = true"><v-icon>mdi-plus</v-icon> Add
                        Entity</v-btn>
                    </span>
                    <span>
                      <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" large icon color="#4EB888" light style="text-decoration: none !important;"
                            :to="{ name: 'search', query: { [clusterParam]: entity.id } }">
                            <v-icon>mdi-format-list-bulleted</v-icon>
                          </v-btn>
                        </template>
                        <span>View all {{ entity.name }} notices</span>
                      </v-tooltip>
                    </span>
                    <span>
                      <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" large icon color="secondary" light style="text-decoration: none !important;"
                            @click="loadCluster">
                            <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                        </template>
                        <span>Reload Cluster</span>
                      </v-tooltip>
                    </span>
                  </v-card-title>
                  <v-row v-if="no_members" class="ma-0 pa-0">
                    <v-divider></v-divider>
                    <v-col cols="12">
                      <v-card flat class="pl-0 pt-0">
                        <v-card-text v-if="entity_type == 'supplier_id'" class="pl-0 pt-0">This cluster is empty.
                          Head over to the <router-link :to="{ name: 'suppliers' }">suppliers</router-link> directory to
                          add entities to
                          it.
                        </v-card-text>
                        <v-card-text v-else-if="entity_type == 'publisher_id'" class="pl-0 pt-0">This cluster is empty.
                          Head over to the <router-link :to="{ name: 'entities' }">buyers</router-link> directory to add
                          entities to it.
                        </v-card-text>
                      </v-card>

                    </v-col>
                  </v-row>
                  <v-row v-else-if="isDataLoaded" class="ma-0 pa-0">
                    <v-divider></v-divider>
                    <v-col cols="12">
                      <search-analysis :query="search"></search-analysis>
                    </v-col>
                  </v-row>

                </v-card>
              </v-col>
            </v-row>
            <v-tabs class="pt-4 pb-1" color="rgb(18, 37, 58)" show-arrows v-if="no_members">
              <v-tab>
                Entities
              </v-tab>
              <v-tab>
                Recent Notices
              </v-tab>
              <v-tab-item></v-tab-item>
              <v-tab-item></v-tab-item>
            </v-tabs>
            <v-tabs v-else class="pt-4 pb-1" color="rgb(18, 37, 58)" show-arrows>
              <v-tabs-slider color="rgb(255, 20, 99)"></v-tabs-slider>
              <v-tab>
                {{ entity_title }}
              </v-tab>
              <v-tab>
                {{ counterparty_title }}
              </v-tab>
              <v-tab>
                Recent Notices
              </v-tab>
              <v-tab-item>
                <v-row style="background-color:#f5f5f5">
                  <v-col cols="12" class="pt-3">
                    <cluster-members-v-2 v-if="isDataLoaded" @reloadCluster="loadCluster" :target_entity="target_entity"
                      :key="loaded" :query="query" :entity_type="entity_type" :cluster_type="clusterParam"
                      :cluster_id="cluster_id"></cluster-members-v-2>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row style="background-color:#f5f5f5">
                  <v-col cols="12" class="pt-3">
                    <cluster-members-v-2 v-if="isDataLoaded" @reloadCluster="loadCluster"
                      :target_entity="target_counterparty" :key="loaded" :query="query" :entity_type="counterparty_type"
                      :cluster_type="clusterParam" :cluster_id="cluster_id" :isCounterparty="true">
                    </cluster-members-v-2>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row style="background-color:#f5f5f5">
                  <v-col cols="12" class="pt-3">
                    <v-skeleton-loader v-if="overlay" type="table-tbody"></v-skeleton-loader>
                    <results-table-vuetify v-else class="pb-3 pt-0 pl-0 pr-0" :hit_info="hit_info" :tenders="tenders"
                      :hide_pagination="true" />
                    <v-overlay absolute="true" :value="overlay">
                      <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Success/Error Notifications -->
    <v-snackbar v-model="notification.show" color="primary" top :timeout="3000">
      {{ notification.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="notification.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {
  executeSearch,
  getCluster,
  getClusterTypes
} from "../components/APIManager.js";
import SearchAnalysis from "../components/SearchAnalysis.vue";
import { growth_format, numFormatter, formattedCurrency, getMonthYear } from "../components/Utils.js";
import ResultsTable from "../components/ResultsTable.vue";
import ResultsTableVuetify from "../components/ResultsTableVuetify.vue";
import ClusterMembersV2 from "../components/ClusterMembersV2.vue";
import ClusterEntitySelector from "../components/ClusterEntitySelector.vue";
import ClusterSupplierSelector from "../components/ClusterSupplierSelector.vue";

export default {
  components: {
    ClusterMembersV2,
    ResultsTableVuetify,
    SearchAnalysis,
    ClusterEntitySelector,
    ClusterSupplierSelector
  },

  data() {
    return {
      addEntitiesWindow: false,
      entity_title: "Members",
      counterparty_title: "Entities",
      counterparty_type: String,
      target_counterparty: String,
      entity: "",
      current_search: Object,
      entity_id: String,
      cluster_id: Number,
      supplier_id: Number,
      entity_ids: Array,
      entity_type: String,
      target_entity: String,
      query: String,
      expiring_activity: [],
      expiry_aggs: [],
      hit_info: {},
      tenders: [""],
      overlay: false,
      tabs: null,
      absolute: true,
      entity_panel: -9,
      entity_panels: [],
      panel_clicked: false,
      //current_index: 0,
      index: Number, //use the exp panel index as key so that we can cache the data
      profiles: [],
      mounted: false,
      total_amt_metric: "total_amount",
      search: Object,
      category_aggs: [],
      date_aggs: [],
      supplier_aggs: [],
      contracting_activity: [],
      publish_activity: [],
      annual_spend: [],
      avg_contract: Number,
      loading_stats: false,
      industry: [],
      clusterParam: String,
      clusterType: "",
      loaded: Number,
      no_members: false,
      clusterTypes: [],
      selectedClusterType: null,
      savingClusterType: false,
      notification: {
        show: false,
        message: ''
      }
    };
  },

  computed: {
    isDataLoaded() {
      if (!this.entity || typeof this.entity !== 'object') return false
      // Entity is loaded when we have minimal required fields; cluster_type_id may be null
      return (
        this.entity.id != null &&
        this.entity.entity_type != null
      )
    }
  },

  created() {

  },

  mounted() {

    this.$nextTick(() => {
      this.loadClusterTypes();
      this.loadCluster();

    });

  },

  watch: {
    $route(to, from) {

    },

    addEntitiesWindow(val){
      if (!val){
        // Reload cluster data when dialog closes
        // Add a small delay to ensure backend has processed the update
        setTimeout(() => {
          this.loadCluster();
        }, 300);
      }
    }

  },

  methods: {

    growth_format,
    numFormatter,
    formattedCurrency,

    reset_route() {

      var qry = JSON.parse(JSON.stringify(this.$route.query));
      delete qry["term"];
      delete qry["page"];
      delete qry["government"];
      delete qry["category"];

      this.$router.replace({ query: null });

      //this.$router.push({ name: "entities", query: qry });
    },

    showNotification(message) {
      this.notification.message = message;
      this.notification.show = true;
    },

    getClusterTypeName(clusterTypeId) {
      const clusterType = this.clusterTypes.find(ct => ct.id === clusterTypeId);
      return clusterType ? clusterType.name : '';
    },

    async loadClusterTypes() {
      try {
        const results = await getClusterTypes();
        this.clusterTypes = results.data || [];
      } catch (error) {
        ////////////console.error('Error loading cluster types:', error);
        this.showNotification('Failed to load cluster types');
      }
    },

    loadCluster() {
      ////////////////////////console.log("QUERY FROM SUPP PROFILE: ", query);
      this.overlay = true;

      //var qry = JSON.parse(JSON.stringify(query));

      return getCluster(this.$route.params.clusterId).then(results => {
        // ////////////console.log('loadCluster - results.data:', results.data);

        this.entity = results.data;
        this.query = results.data.search_query;
        // ////////////console.log('loadCluster - query:', this.query);

        // Set the selected cluster type to the current cluster's type
        this.selectedClusterType = results.data.cluster_type_id;

        if (this.entity.entity_type == "publisher") {
          this.clusterParam = "buyer_cluster";
          this.clusterType = "Buyer Cluster";
          this.target_entity = "entity";
          this.counterparty_type = "supplier_id";
          this.target_counterparty = "supplier";
          this.entity_title = "Buyers"
          this.counterparty_title = "Suppliers"
        }
        else {
          this.clusterParam = "supplier_cluster";
          this.clusterType = "Supplier Cluster"
          this.target_entity = "supplier";
          this.counterparty_type = "publisher_id";
          this.target_counterparty = "entity";
          this.entity_title = "Suppliers"
          this.counterparty_title = "Buyers"
        }
        this.search = { [this.clusterParam]: [this.$route.params.clusterId], size: 1 };
        ////////////////////console.log("----SEARCH----\n: ", this.search);
        this.entity_type = results.data.entity_type + '_id';

        ////////////////console.log("QUERY: ", this.query);
        ////////////////console.log("ENTITY TYPE: ", JSON.parse(this.query)["supplier_id"]);

        var q = JSON.parse(this.query);
        // //////////console.log('loadCluster - parsed query:', q);
        // //////////console.log('loadCluster - entity_type:', this.entity_type);
        // //////////console.log('loadCluster - entities in query:', q[this.entity_type]);

        // Always set cluster_id and clusterName
        this.cluster_id = results.data.id;
        this.clusterName = results.data.name;

        if (q[this.entity_type].length <= 0) {
          // //////////console.log('loadCluster - no members found');
          this.no_members = true;
        }
        else {
          // //////////console.log('loadCluster - members found, updating cluster data');
          this.no_members = false;
          //////////////////console.log("----CLUSTER DATA----\n: ", results.data);
          this.loadRecentAwards();
        }

        // Always update loaded key to force re-render of components
        this.loaded = Math.random() * Math.random();
        this.overlay = false;

        return results;
      });
    },

    reset_aggs() {
      this.expiry_aggs = [];
      this.expiring_activity = [];
      this.date_aggs = [];
      this.contracting_activity = [];
      this.publish_activity = [];
      this.annual_spend = [];
      this.category_aggs = [];
      this.supplier_aggs = [];
    },


    async loadRecentAwards() {
      let results = {};

      //let labels = [];
      results = await executeSearch(
        JSON.stringify({
          [this.clusterParam]: this.$route.params.clusterId,
          //disposition: "Contract Notice",
          sort_field: "expiry_date",
          sort_order: "desc",
          size: 10
        })
      );

      //////////////////////console.log("TABLE RESULTS: ", results)

      this.tenders = results.data;
      this.hit_info = results.hits;
      this.overlay = false;
    },



    disableIcon(url) {
      if (!url) {
        return true;
      } else {
        return false;
      }
    },

    toggle() {
      this.watching = !this.watching;
      this.is_saved();
    },

    is_saved() {
      //////////////////////console.log("NOTIFY STATUS: " + this.current_search.notify)
      return this.watching;
    },

    async onClusterTypeChange(newClusterTypeId) {
      // Don't save if it's the same as the current value or if we're still loading
      if (!newClusterTypeId || newClusterTypeId === this.entity.cluster_type_id || this.savingClusterType) {
        return;
      }

      this.savingClusterType = true;

      try {
        // Update the cluster with the new cluster type
        const updateData = {
          id: this.entity.id,
          name: this.entity.name,
          entity_type: this.entity.entity_type,
          cluster_type_id: newClusterTypeId,
          owner_id: this.entity.owner_id
        };

        const response = await fetch(process.env.VUE_APP_API_CLUSTER, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${await this.$auth.getTokenSilently()}`
          },
          body: JSON.stringify(updateData)
        });

        if (response.ok) {
          // Update the local entity data
          this.entity.cluster_type_id = newClusterTypeId;

          // Update the selected cluster type to reflect the change immediately
          this.selectedClusterType = newClusterTypeId;

          // Show success notification
          this.showNotification('Cluster type updated successfully');
        } else {
          // Revert the selection if the save failed
          this.selectedClusterType = this.entity.cluster_type_id;
          throw new Error('Failed to update cluster type');
        }
      } catch (error) {
        //////////console.error('Error updating cluster type:', error);
        this.showNotification('Failed to update cluster type');
        // Revert the selection on error
        this.selectedClusterType = this.entity.cluster_type_id;
      } finally {
        this.savingClusterType = false;
      }
    },

    onEntitiesAdded(entities) {
      // //////////console.log('onEntitiesAdded called with entities:', entities);
      // //////////console.log('Current entity type:', this.entity.entity_type);

      // Close the dialog
      this.addEntitiesWindow = false;

      // Reload the cluster to show new entities
      this.loadCluster().then(() => {
        // //////////console.log('loadCluster completed, components should re-render automatically');
      });
    },

    onSuccess(message) {
      this.showNotification(message);
    },

    onError(message) {
      this.showNotification(message);
    }
  }
};
</script>

<style>
.chart {
  border-color: #424242 !important;
}

.headingUnderline {
  border-color: aqua !important;
}
</style>
